import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { UserState } from '@api/models/enums/UserState';
import { UserRole } from '@api/models/enums/UserRole';
import { supplierEmployeeService } from '@api/services/services';

type State = BaseType<SupplierEmployeeDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsSupplierEmployeeSlice = baseSlice({
  name: 'optionsSupplierEmployee',
  initialState,
});

export const selectOptionsSupplierEmployeeState = (state: RootState) => state.optionsSupplierEmployee.state;
export const selectOptionsSupplierEmployee = (state: RootState) => state.optionsSupplierEmployee.data;
export const optionsSupplierEmployeeActions = optionsSupplierEmployeeSlice.actions;

export const getOptionsSupplierEmployee =
  (supplierId: string, search: string | undefined, role: UserRole | undefined, state: UserState[] | undefined, cancelToken: CancelToken) =>
  (dispatch: AppDispatch) => {
    const handleGetData = async () => {
      //Load whole entity for create invitation.
      const response = await supplierEmployeeService.query(
        { supplierId: supplierId, q: search, state: state, role: role, page: 0, size: AUTOCOMPLETE_MAX_ITEMS, sort: ['name', 'asc'] },
        {
          cancelToken: cancelToken as any,
        }
      );
      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsSupplierEmployeeActions,
      getData: handleGetData,
    });
  };
